import { Edge } from "@xyflow/react";
import { StateProps } from "./classes/state-machine/state";
import { StatesMachine } from "./classes/state-machine/state-machine";

export function canInsertOperation(
  machine: StatesMachine | undefined,
  operation: StateProps["operation"]
) {
  if (!machine) return false;
  if (["START", "END"].includes(operation)) return false;

  return !machine.states.some((state) => state.operation === operation);
}

export function getVisibleStateIdForInsertedOperation(
  machine: StatesMachine,
  operation: StateProps["operation"]
) {
  const previewStateMachine = machine.clone();
  const previewCreatedState = previewStateMachine.addOperationState(operation);

  return previewStateMachine.getVisibleStateId(previewCreatedState.id);
}

export function addOperation(
  machine: StatesMachine,
  operation: StateProps["operation"]
) {
  machine.addOperationState(operation);
}

export function connectStatesIfAllowed(
  machine: StatesMachine,
  sourceId: number,
  targetId: number
): string | null {
  const blockedReason = machine.getConnectionBlockedReason(sourceId, targetId);
  if (!blockedReason) {
    machine.connectStates(sourceId, targetId);
  }
  return blockedReason;
}

export function disconnectStates(
  machine: StatesMachine,
  sourceId: number,
  targetId: number
) {
  machine.disconnectStates(sourceId, targetId);
}

export function parseEdgeIdsFromDeletableEdgeId(edgeId: string) {
  const [, src, tgt] = edgeId.split("-");
  const sourceId = Number(src);
  const targetId = Number(tgt);

  if (!sourceId || !targetId) return null;

  return { sourceId, targetId };
}

export function disconnectEdges(machine: StatesMachine, edges: Edge[]) {
  edges.forEach((edge) => {
    const sourceId = Number(edge.source);
    const targetId = Number(edge.target);

    if (!sourceId || !targetId) return;
    machine.disconnectStates(sourceId, targetId);
  });
}
